export function CardSkeleton() {
  return (
    <div className="bg-surfaceSecondary border border-hair rounded-xl p-6 animate-pulse">
      <div className="h-3 w-20 bg-surfaceTertiary rounded-full mb-4" />
      <div className="h-5 w-full bg-surfaceTertiary rounded mb-2" />
      <div className="h-5 w-4/5 bg-surfaceTertiary rounded mb-4" />
      <div className="h-3 w-2/3 bg-surfaceTertiary rounded" />
    </div>
  );
}

export function HeroSkeleton() {
  return (
    <div className="bg-surfaceSecondary border border-hair rounded-2xl p-8 animate-pulse">
      <div className="h-3 w-24 bg-surfaceTertiary rounded-full mb-5" />
      <div className="h-9 w-full bg-surfaceTertiary rounded mb-3" />
      <div className="h-9 w-3/4 bg-surfaceTertiary rounded mb-5" />
      <div className="h-4 w-full bg-surfaceTertiary rounded mb-2" />
      <div className="h-4 w-2/3 bg-surfaceTertiary rounded" />
    </div>
  );
}

export function ArticleSkeleton() {
  return (
    <div className="animate-pulse space-y-4">
      <div className="h-3 w-24 bg-surfaceTertiary rounded-full" />
      <div className="h-10 w-full bg-surfaceTertiary rounded" />
      <div className="h-10 w-2/3 bg-surfaceTertiary rounded" />
      <div className="h-5 w-full bg-surfaceTertiary rounded mt-6" />
      {Array.from({ length: 8 }).map((_, i) => (
        <div key={i} className="h-4 w-full bg-surfaceTertiary rounded" />
      ))}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, subtitle, action }) {
  return (
    <div data-testid="empty-state" className="flex flex-col items-center justify-center text-center py-20 px-6">
      {Icon && <Icon size={40} className="text-subtle mb-4" />}
      <p className="font-serif text-xl text-onSurface">{title}</p>
      {subtitle && <p className="text-sm text-subtle mt-2 max-w-sm">{subtitle}</p>}
      {action}
    </div>
  );
}
